import { Box, Card, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";

import { Info } from "@mui/icons-material";
import { getColor } from "../../../style/color/color";
import { formatToIndianCurrency } from "../../../logic/CurrencyFormatter";
import { String } from "../../../constants/Strings";
import { fonts } from "../../../style/fonts/fonts";

const TotalAssetAmountCard = ({ monthlySaving, monthlyIncome }) => {
  return (
    <Card
      sx={{
        background: getColor.SecondarySummerSky,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        p: 2,
        borderRadius: 3,
      }}
    >
      <Box sx={{ mb: "30px", p: 1 }}>
        <Typography
          sx={{
            color: getColor.PrimaryWhite,
            fontSize: 20,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {formatToIndianCurrency(monthlySaving)}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.totolAMountCardTooltip.titleMonthlysaving}
          </Typography>
          <Tooltip
            title={String.Dashboard.totolAMountCardTooltip.monthlySavingTitle}
            sx={{ position: "relative", ml: "5px" }}
            enterTouchDelay={0}
          >
            <IconButton>
              <Info
                sx={{
                  width: 12,
                  height: 12,
                  fontSize: "1rem",
                  color: getColor.PrimaryWhite,
                  left: 0,
                  top: 4,
                  position: "absolute",
                  cursor: "pointer",
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Box sx={{ mb: "30px", p: 1 }}>
        <Typography
          sx={{
            color: getColor.PrimaryWhite,
            fontSize: 20,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {formatToIndianCurrency(monthlyIncome)}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.totolAMountCardTooltip.MonthlyIncomeTitle}
          </Typography>
          <Tooltip
            title={String.Dashboard.totolAMountCardTooltip.MonthlyIncomeTooltip}
            sx={{ position: "relative", ml: "5px" }}
            enterTouchDelay={0}
          >
            <IconButton>
              <Info
                sx={{
                  width: 12,
                  height: 12,
                  fontSize: "1rem",
                  color: getColor.PrimaryWhite,
                  left: 0,
                  top: 4,
                  position: "absolute",
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Card>
  );
};

export default TotalAssetAmountCard;
